import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";

import {
  WelcomeContainer,
  ImgContainer,
  OptionsContainer,
} from "./Welcome.elements";
import options from "../../img/options.svg";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../services/firebase";
import { Link } from "react-router-dom";
import Loading from "../Loading/Loading";

function Welcome() {
  const [rooms, setRooms] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const randomElements = (array) => {
    const randomArray = [];
    for (let i = 0; i < 3; ) {
      const randomId = Math.floor(Math.random() * array.length);
      if (randomArray.indexOf(array[randomId]) !== -1) {
        continue;
      }
      randomArray.push(array[randomId]);
      i++;
    }
    return randomArray;
  };

  useEffect(() => {
    setIsLoading(true);
    onSnapshot(collection(db, "rooms"), (snapshot) => {
      const chosenRooms = randomElements(snapshot.docs).map((el) => ({
        ...el.data(),
        id: el.id,
      }));
      setIsLoading(false);
      setRooms(chosenRooms);
    });
  }, []);
  return (
    <WelcomeContainer>
      <OptionsContainer>
        <h1>Welcome to Slack!</h1>
        <h3>Here are some channel suggestions</h3>
        {isLoading && <Loading />}
        {rooms && (
          <ul>
            {rooms.map((room) => (
              <li key={room.id}>
                <Button>
                  <Link to={`/channel/${room.id}`}>{room.name}</Link>
                </Button>
              </li>
            ))}
          </ul>
        )}
      </OptionsContainer>
      <ImgContainer>
        <img src={options} alt="options" />
      </ImgContainer>
    </WelcomeContainer>
  );
}

export default Welcome;
